import React from "react";

type CounterBadgeProps = {
  count: number;
  className?: string;
  dataTestId?: string;
};

export const CounterBadge = ({ count, className, dataTestId }: CounterBadgeProps) => (
  <div className={`counter-badge ${className}`} data-testid={dataTestId}>
    {count}
  </div>
);
